<script setup lang="ts">
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { setFile } from "../../states/chatFiles";
import { scrollIfBottom } from "../../states/scrollChatState";

const props = defineProps<{
  modelValue: string;
  placeholder: string;
}>();

const input = ref<HTMLInputElement | null>(null);

const emit = defineEmits<{
  (e: "update:modelValue", data: string): void;
  (e: "submit"): void;
}>();
const value = computed({
  get() {
    return props.modelValue;
  },
  set(val: string) {
    emit("update:modelValue", val);
  },
});
function resizeTextArea() {
  nextTick(() => {
    if (input.value) {
      input.value.style.height = "19px";
      input.value.style.height = input.value.scrollHeight + "px";
      scrollIfBottom();
    }
  });
}
onMounted(() => {
  if (input.value) {
    input.value.addEventListener("input", resizeTextArea);
    resizeTextArea();
    watch(() => props.modelValue, resizeTextArea);
  }
});
const keyPress = (event: KeyboardEvent) => {
  if (
    (event.ctrlKey && event.code === "Enter") ||
    (event.shiftKey && event.code === "Enter") ||
    (event.altKey && event.code === "Enter")
  ) {
    event.preventDefault();
    const textarea = input.value;
    if (textarea) {
      const start = textarea.selectionStart as number;
      const end = textarea.selectionEnd as number;

      // Вставляем перенос строки
      textarea.value =
        textarea.value.substring(0, start) +
        "\n" +
        textarea.value.substring(end);
      textarea.selectionStart = textarea.selectionEnd = start + 1; // перемещаем курсор
      textarea.scrollTop += 24;
      value.value = textarea.value;
      resizeTextArea();
    }
  } else if (event.key === "Enter") {
    event.preventDefault();
    emit("submit");
  }
};
const paste = async () => {
  const items = await navigator.clipboard.read();
  for (const item of items) {
    if (!Object.keys(maptypes).includes(item.types[0])) return;
    const type = item.types[0] as keyof typeof maptypes;
    const blob = await item.getType(item.types[0]);
    const file = new File(
      [blob],
      `file_${new Date().getTime()}.${maptypes[type]}`,
      { type },
    );
    setFile(file);
  }
};
const maptypes = {
  "image/jpeg": "jpg",
  "image/png": "png",
};
</script>
<template>
  <textarea id="chat-text-area" class="font-with-emoji" maxlength="8000" :placeholder="placeholder" ref="input"
    v-model="value" :onkeypress="keyPress" @paste="paste" />
</template>
<style scoped>
textarea {
  min-height: 19px;
  line-height: 19px;
  max-height: 76px;
  background-color: transparent;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  color: #ffffff;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  resize: none;
}

textarea::-webkit-scrollbar {
  width: 10px;
}

textarea::-webkit-scrollbar-thumb {
  background: #676666;
  border-radius: 8px;
  border: 3px solid #2c2828;
}

textarea::-webkit-scrollbar-track {
  background: transparent;
}

textarea:focus,
textarea:hover {
  border: none;
  outline: none;
}

textarea::placeholder {
  color: #a4a4a4;
}
</style>
